import styled from 'styled-components'

export const FormContainer = styled.form`
  margin-bottom: 2rem;
  width: 100%;
  max-width: 760px;
  display: flex;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  margin: auto;
`
